import SectorQueue from './SectorQueue'

function Cut() {
    return <SectorQueue sector="Corte" />
}

export default Cut
